import { useMutation } from "@shared/lib/hooks";
import { ToastService } from "@shared/lib/services";
import { InfluencerService } from "../lib/services/manage.influencer.requests.service";
import {
  INFLUENCER_LIST_QUERY_KEY,
  INFLUENCER_REQUESTS_QUERY_KEY,
} from "@entities/influencer/lib/constants";
import {
  ICreateInfluencerRequest,
  IInfluencerRequestAdd,
} from "@shared/lib/types/influencer";
import { INFLUENCER_REQUEST_FACETS } from "../lib/constants";

export function useApproveInfluencer() {
  const {
    mutate: approveInfluencer,
    isLoading: isApproving,
    isSuccess: isApproved,
    isError: isApproveFailed,
  } = useMutation({
    mutationFn: async ({
      influencerAgencyRequestId,
      updatedDetails,
      remarks,
    }: {
      influencerAgencyRequestId: string;
      updatedDetails: ICreateInfluencerRequest;
      remarks?: string;
    }) => {
      return await InfluencerService.approveInfluencer(
        influencerAgencyRequestId,
        updatedDetails,
        remarks
      ).catch(async (err) => {
        const responseBody = await err.response.json();
        ToastService.error(responseBody.msg);
        throw err;
      });
    },
    options: {
      skipInvalidation: true,
    },
    onSuccess: (c) => {
      // retrigger request facets on approve to get the updated pending count
      setTimeout(() => {
        c.invalidateQueries({
          queryKey: [...INFLUENCER_REQUEST_FACETS],
        });
        c.invalidateQueries({
          queryKey: [...INFLUENCER_REQUESTS_QUERY_KEY],
        });
      }, 1000);
    },
  });

  return {
    approveInfluencer,
    isApproving,
    isApproved,
    isApproveFailed,
  };
}
